import React from "react";
import { browserHistory } from "react-router";
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'
import locale from './locale'
import ClientInfoTD from './ClientInfoTD'
import TagListTD from './TagListTD'

export default function() {
  return getDefaultTableFields.call(this);
}

function getDefaultTableFields() {
  let TabComponent = this;
  let {dispatch} = this.props

  return [{
    name: 'name',
    title: __('Name', locale),
    getTdProps: ({tbodyData})=>{
      return {
        style: {width: "27%"}
      }
    },
    getTdContent: ({ trData: data })=>{
      return <ClientInfoTD client={data} fetchClientList={this.fetchClientList}/>
    },
  }, {
    name: 'age',
    title: __('Age', locale),
    getTdProps: ({tbodyData})=>{
      return {
        style: {width: "7%"}
      }
    },
  },{
    name: 'mobile',
    title: __('Contact Number', locale),
    getTdProps: ({tbodyData})=>{
      return {
        style: {width: "15%"}
      }
    },
  },{
    name: 'guardian_name',
    title: __('Guardian Name', locale),
    getTdProps: ({tbodyData})=>{
      return {
        style: {width: "15%"}
      }
    },
  }, {
    name: 'tag_name_list',
    title: __('Tags', locale),
    getTdProps: ({tbodyData})=>{
      return {
        style: {width: "27%"}
      }
    },
    getTdContent: ({ trData: data })=>{
      return <TagListTD client={data} />
    },
  }]
}



// WEBPACK FOOTER //
// ./src/containers/pages/PotentialClient/table-fields.js